import { Injectable } from '@angular/core';

declare global {
  interface Window {
    renderBotWidget: (id: string, config: any, restart?: boolean, customId?: boolean) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class BotAjudaCaixaService {
  private scriptLoaded = false;
  private chatbotInitialized = false;
  private readonly CHATBOT_ID = '68deb138a857cc299b2c13b4';

  constructor() { }

  /**
   * Carrega o script do chatbot de forma assíncrona
   */
  loadChatbot(): void {
    // Evita carregar o script multiplas vezes
    if (this.scriptLoaded) {
      this.initializeChatbot();
      return;
    }

    // Cria e carrega o script principal do chatbot
    const script = document.createElement('script');
    script.src = 'https://cdn.boteria.com.br/webchat.js';
    script.async = true;

    // Aguarda o script carregar antes de inicializar o widget
    script.onload = () => {
      this.scriptLoaded = true;
      this.initializeChatbot();
    };

    script.onerror = () => {
      console.error('Chatbot-Caixa: Erro ao carregar o script');
    };

    document.head.appendChild(script);
  }

  /**
   * Inicializa o widget do chatbot para Caixa
   */
  private initializeChatbot(): void {
    // Evita inicializar múltiplas vezes
    if (this.chatbotInitialized) return;

    // Verifica se a função global do chatbot está disponível
    if (typeof window.renderBotWidget === 'function') {
      try {
        window.renderBotWidget(
          this.CHATBOT_ID,
          {
            var_title: "var_value", // Variavel da sessao
            layout: {
                //'bot-name': 'Atendimento Caixa', // Nome do bot
                // 'bot-bg-color': '278222', // Cor de fundo da mensagem do bot.
                // 'bot-text-color': 'fff', // Cor do texto da mensagem do bot.
                // 'user-bg-color': '6a5837', // Cor de fundo da mensagem do usuário e do título do chat.
                // 'user-text-color': 'fff0f0', // Cor do texto da mensagem do usuário e do título do chat.
            }
          },
          false, // Define se é para reiniciar a sessao caso os parametros sejam alterados
          false, // Define um id customizado para o elemento que vai renderizar o webchat no html
        );

        this.chatbotInitialized = true;
        console.log('Chatbot Caixa inicializado com sucesso');
      } catch (error) {
        console.error('Chatbot-Caixa: Erro ao inicializar o widget', error);
      }
    } else {
      console.error('Chatbot-Caixa: Função renderBotWidget não encontrada');
    }
  }

  /**
   * Remove o widget do chatbot
   */
  removeChatbot(): void {
    this.chatbotInitialized = false;

    // Remove todos os elementos relacionados ao chatbot
    const widgetElements = document.querySelectorAll('[id*="webchat"], [class*="webchat"], [class*="boteria"]');
    widgetElements.forEach(element => {
      element.remove();
    });
  }

  /**
   * Verifica se o chatbot esta inicializado
   */
  isChatbotActive(): boolean {
    return this.chatbotInitialized;
  }

  /**
   * Verifica se o script está carregado
   */
  isScriptLoaded(): boolean {
    return this.scriptLoaded;
  }
}
